document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.averas-mobile-menu a').forEach((link) => {
    link.addEventListener('click', () => link.closest('details')?.removeAttribute('open'));
  });

  document.querySelectorAll('[data-film-frame]').forEach((frame) => {
    const video = frame.querySelector('[data-brand-film]');
    const button = frame.querySelector('[data-sound-toggle]');
    const label = frame.querySelector('[data-sound-label]');
    if (!video || !button) return;

    video.muted = true;
    const source = video.querySelector('source[data-src]');
    const loadVideo = () => {
      if (source?.dataset.src && !source.src) {
        source.src = source.dataset.src;
        video.load();
      }
    };
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadVideo();
            if (!reducedMotion) video.play().catch(() => {});
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, { rootMargin: '240px 0px' });
      observer.observe(frame);
    } else {
      loadVideo();
    }
    button.addEventListener('click', () => {
      loadVideo();
      video.muted = !video.muted;
      if (video.paused) video.play().catch(() => {});
      button.setAttribute('aria-pressed', String(!video.muted));
      if (label) label.textContent = video.muted ? '音をオン' : '音をオフ';
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const json = root.querySelector('[data-product-variants]');
    const form = root.querySelector('.averas-product-form');
    if (!json || !form) return;

    const variants = JSON.parse(json.textContent).variants || [];
    const groups = [...root.querySelectorAll('[data-option-index]')];
    const hiddenId = form.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const paymentButton = form.querySelector('[data-payment-button]');
    const gallery = root.querySelector('[data-product-gallery]');

    const selectedOptions = () => groups.map((group) =>
      group.querySelector('.averas-option-button.is-selected')?.dataset.optionValue || ''
    );

    const findVariant = (options) => variants.find((variant) =>
      variant.options.every((option, index) => option === options[index])
    );

    const setOptionSelections = (options) => {
      groups.forEach((group, index) => {
        const selectedValue = options[index];
        group.querySelectorAll('[data-option-value]').forEach((button) => {
          const selected = button.dataset.optionValue === selectedValue;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
      });
    };

    const selectMedia = (variant, changedGroup) => {
      let media = variant?.mediaId
        ? root.querySelector(`[data-media-id="${variant.mediaId}"]`)
        : null;

      if (!media && changedGroup?.classList.contains('is-color')) {
        const color = changedGroup.querySelector('.is-selected')?.dataset.optionValue?.toLowerCase();
        if (color) {
          media = [...root.querySelectorAll('[data-media-alt]')].find((item) =>
            item.dataset.mediaAlt.includes(color)
          );
        }
      }

      if (!media) media = root.querySelector('.averas-product-media.is-selected');
      if (!media) media = root.querySelector('.averas-product-media');
      if (!media) return;
      root.querySelectorAll('.averas-product-media').forEach((item) => item.classList.remove('is-selected'));
      media.classList.add('is-selected');
      if (changedGroup) {
        if (window.matchMedia('(max-width: 760px)').matches) {
          gallery?.scrollTo({ left: media.offsetLeft - 16, behavior: 'smooth' });
        } else {
          media.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    };

    const updateAvailability = (options) => {
      groups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-option-value]').forEach((button) => {
          // Color changes may safely move to an available size in that color.
          // Size and other option changes preserve every current choice so
          // the shopper is never moved to another color without noticing.
          const isColor = group.classList.contains('is-color');
          const available = variants.some((variant) => variant.available &&
            variant.options.every((option, index) => {
              if (index === groupIndex) return option === button.dataset.optionValue;
              if (!isColor) return option === options[index];
              return true;
            })
          );
          button.classList.toggle('is-unavailable', !available);
          button.disabled = !available;
          button.setAttribute('aria-disabled', String(!available));
        });
      });
    };

    const invalidatePurchase = () => {
      hiddenId.value = '';
      hiddenId.dispatchEvent(new Event('change', { bubbles: true }));
      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = '選択できません';
      }
      if (paymentButton) paymentButton.hidden = true;
    };

    const updateVariantUrl = (variantId) => {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    };

    const updateProduct = (changedGroup) => {
      const options = selectedOptions();
      const variant = groups.length
        ? findVariant(options)
        : (variants.find((item) => item.available) || variants[0]);
      updateAvailability(options);
      if (!variant) {
        invalidatePurchase();
        return;
      }

      if (variant.available) {
        hiddenId.value = variant.id;
        hiddenId.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        hiddenId.value = '';
        hiddenId.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (price) price.textContent = variant.price;
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'カートに追加' : 'SOLD OUT';
      }
      if (paymentButton) paymentButton.hidden = !variant.available;
      updateVariantUrl(variant.id);
      selectMedia(variant, changedGroup);
    };

    const chooseSafeVariant = (changedIndex, requestedValue, changedGroup) => {
      const requested = selectedOptions();
      requested[changedIndex] = requestedValue;

      const exact = findVariant(requested);
      if (exact?.available) return exact;

      const changedColor = changedGroup?.classList.contains('is-color');
      const candidates = variants.filter((variant) => variant.available &&
        variant.options.every((option, index) => {
          if (index === changedIndex) return option === requestedValue;
          if (!changedColor) return option === requested[index];
          return true;
        })
      );

      // Exact matches above preserve every current selection. Only when that
      // exact combination is sold out do we move to another available option.
      return candidates.sort((a, b) => {
        const score = (variant) => variant.options.reduce((total, option, index) =>
          total + (index > changedIndex && option === requested[index] ? 1 : 0), 0
        );
        return score(b) - score(a);
      })[0] || null;
    };

    groups.forEach((group, groupIndex) => {
      group.querySelectorAll('[data-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          const safeVariant = chooseSafeVariant(groupIndex, button.dataset.optionValue, group);
          if (!safeVariant) {
            invalidatePurchase();
            return;
          }
          setOptionSelections(safeVariant.options);
          updateProduct(group);
        });
      });
    });

    updateProduct(null);
  });
});
